import { format, setMonth } from "date-fns";

export const formatPeriod = (
  period?: number,
  termCode?: string,
  validFrom?: string
) => {
  if (termCode === "YEARLY") {
    return period && validFrom
      ? new Date(validFrom).getFullYear().toString()
      : "Yearly";
  }
  if (termCode === "MONTHLY") {
    return format(setMonth(new Date(), period ? period - 1 : 0), "LLLL");
  }

  if (termCode === "QUARTERLY") {
    return `Q${period}`;
  }

  if (termCode === "HALF_YEAR") {
    return period === 1 ? "Jan - Jun" : "Jul - Dec";
  }

  if (termCode === "USER_DEF") {
    return "Custom";
  }

  return `${period}:${termCode}`;
};

export const resolveRebateModel = (rebateModelCode?: string | null) => {
  if (rebateModelCode === "L") {
    return {
      code: "L",
      description: "Linear",
    };
  }

  if (rebateModelCode === "P") {
    return {
      code: "LP",
      description: "Progressive and linear",
    };
  }

  if (rebateModelCode === "R") {
    return {
      code: "R",
      description: "Retroactive",
    };
  }

  if (rebateModelCode === "RP") {
    return {
      code: "RP",
      description: "Progressive and retroactive",
    };
  }

  return {
    code: rebateModelCode,
    description: "Unknown model code",
  };
};
